// extracted by mini-css-extract-plugin
module.exports = {"dot":"_lh","department":"_li","departmentContent":"_lj","departmentbiggerText":"_lk","departmentText":"_ll"};